<div class="load-more-blk">
  <span class="loading">
    <img class="home_logo loading-jkps" src="assets/images/logo.png" alt="logo" />     
</span>
</div>
